<div class="card-header d-flex justify-content-between align-content-end collapsed" aria-expanded="false" aria-controls="informationalCollapse" (click)="toggleExpander($event)">
  <h5 class="mb-0">Informational</h5>
  <i aria-hidden="true"></i>
</div>
<div [attr.id]="'collapse-' + informationalCriteria?.expanderID" class="collapse" aria-labelledby="headingThree">
    <div class="card-body">
      <ol *ngIf="informationalCriteriaExists">
        <li *ngFor="let criteria of informationalCriteria.criteriaLabels">{{ criteria.label }}</li>
      </ol>
      <h6 *ngIf="!informationalCriteriaExists">There are currently no criteria for this section.</h6>
    </div>
</div>